import { Action, createAction, handleActions } from "redux-actions";
import {
  CotizacionListItem,
  EstadoValue,
  GetCotizacionesResponse,
  NegocioValue,
  RowsValue,
  Services,
} from "../types";

interface GetCotizacionesCompletedPayload {
  cotizaciones: CotizacionListItem[];
  totalRegistros: number;
  isAnOldRequest?: boolean;
}

interface CotizacionesState {
  isLoading: boolean;
  cotizaciones: CotizacionListItem[] | null;
  totalRegistros: number;
  failed: boolean;
  isPageAlreadyLoad?: boolean;
  take?: RowsValue;
}

const setInitialState = createAction("SET_COTIZACIONES_INITIAL_STATE");

const getCotizacionesInited = createAction("OBTENER_COTIZACIONES_INITED");

const getCotizacionesCompleted = createAction(
  "OBTENER_COTIZACIONES_COMPLETED",
  (
    response: GetCotizacionesResponse | null | undefined,
    isAnOldRequest?: boolean
  ): GetCotizacionesCompletedPayload => {
    let cotizaciones: CotizacionListItem[] = [];
    let totalRegistros = 0;

    if (response != null) {
      cotizaciones = response.multicotizaciones;
      totalRegistros = response.totalRegistros;
    }

    return { cotizaciones, totalRegistros, isAnOldRequest };
  }
);
const getCotizacionesFailed = createAction(
  "OBTENER_COTIZACIONES_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getCotizaciones = (
  skip: number,
  take: RowsValue,
  fechaDesde: Date | "" | null,
  fechaHasta: Date | "" | null,
  searchCriteria: string,
  negocio: NegocioValue,
  estado: EstadoValue
) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(getCotizacionesInited());

      const data = {
        skip,
        take,
        fechaDesde,
        fechaHasta,
        searchCriteria,
        negocio,
        estado,
      };

      const response = await services.api.cotizaciones().getCotizaciones(data);
      dispatch(getCotizacionesCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getCotizacionesFailed(error));
    }
  };
};

const cotizacionesInitialState: CotizacionesState = {
  isLoading: false,
  cotizaciones: null,
  totalRegistros: 0,
  failed: false,
};

const cotizacionesReducer = handleActions<CotizacionesState, any>(
  {
    [setInitialState.toString()]: (
      state: CotizacionesState
    ): CotizacionesState => {
      return {
        ...cotizacionesInitialState,
        take: state.take,
        cotizaciones: null,
        isLoading: true,
      };
    },
    [getCotizacionesInited.toString()]: (
      state: CotizacionesState
    ): CotizacionesState => {
      return {
        ...state,
        totalRegistros: 0,
        isLoading: true,
      };
    },
    [getCotizacionesCompleted.toString()]: (
      state: CotizacionesState,
      action: Action<GetCotizacionesCompletedPayload>
    ): CotizacionesState => {
      return {
        ...state,
        cotizaciones: action.payload.cotizaciones,
        totalRegistros: action.payload.totalRegistros,
        isLoading: false,
        failed: false,
      };
    },
    [getCotizacionesFailed.toString()]: (
      state: CotizacionesState
    ): CotizacionesState => {
      return {
        ...state,
        isPageAlreadyLoad: false,
        isLoading: false,
        failed: true,
      };
    },
  },
  cotizacionesInitialState
);

export { cotizacionesReducer };
export { getCotizaciones, setInitialState };
